export const USER_ACCESS_LIST_VARIANT = Object.freeze({
  OWNER: 'owner',
  CURRENT_SHARER: 'currentSharer',
  GRANT: 'grant',
  EXTERNAL: 'external',
  PENDING_INVITE: 'pendingInvite',
})
